
export const getUniqItems = (items, getId) => {
  const existingItems = {}
  
  return items.filter((item) => {
    const id = getId(item)

    if (existingItems[id]) return false;

    existingItems[id] = true;
    return true;
  });
}